import { Image } from "react-bootstrap";
import PropTypes from "prop-types";

import { emotionColorMap, emotionImageMap } from "../../helpers/charts";
import { emotionToFields } from "../helpers/reportHelpers";
import { useUser } from "../../UserContext";

const EmotionBadge = ({ emotion }) => {
	const { respondent } = useUser();
	const stats = respondent?.weqProfile?.stats || {};
	const emotionField = emotionToFields[emotion];
	if (typeof stats[emotionField] === "undefined") {
		return null;
	}
	return (
		<div className={`emotion-badge align-items-center fs-18 gap-1 d-flex emotion-badge--${emotion.toLowerCase()}`}>
			<Image alt={emotion} src={emotionImageMap[emotion]} style={{ minWidth: '48px', width: '30%' }} />
			<div className="d-flex flex-column">
				<div className="fw-bold d-flex align-items-center">
					<span className={`rounded-circle d-inline-block bg-${emotionColorMap[emotion]} me-1`} height="10" style={{ height: "10px", width: "10px" }} width="10" />
					{emotion}
				</div>
				<div className="emotion-badge__score text-secondary">
					{stats[`${emotionField}_dist`]?.toFixed(2)}%
				</div>
			</div>
		</div>
	)
};

EmotionBadge.propTypes = {
	emotion: PropTypes.string.isRequired
};

export default EmotionBadge;